import { render } from "./VistaStock.vue?vue&type=template&id=67c58cc8"
import script from "./VistaStock.vue?vue&type=script&lang=js"
export * from "./VistaStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__